<mat-select #contactTypeSelect [placeholder]="placeholder" (selectionChange)="onSelectionChange()"
    (openedChange)="openedChange($event)" [compareWith]="compareWith" [disabled]="isDisabled" [formControl]="selectCtrl"
    [tabIndex]="tabIndex">

    <mat-option *ngFor="let item of (surveyMailContactTypes$ | async) | orderBy: 'name': false"
        [value]="item.contactRoleGroupId">
        {{item.name }}</mat-option>

</mat-select>